<template>
  <div>
    <!-- Заголовок всегда видим -->
    <div class="row mb-2">
      <div class="col-11">
        <input v-model="data.label" class="form-control" placeholder="Заголовок" />
      </div>
      <div class="col-1">
        <button class="btn btn-icon" @click="toggleAll">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M3 9l4 -4l4 4m-4 -4v14" />
            <path d="M21 15l-4 4l-4 -4m4 4v-14" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Карточки FAQ сворачиваются полностью -->
    <draggable
        v-if="!allCollapsed"
        v-model="data.items"
        item-key="id"
        handle=".drag-handle"
        animation="150"
        ghost-class="drag-ghost"
    >
      <template #item="{ element: el, index }">
        <div class="card border mb-2">
          <div class="card-body">

            <!-- Верхняя панель с drag и вопросом -->
            <div class="d-flex align-items-center mb-1">
              <span class="drag-handle me-2" style="cursor: grab;">☰</span>
              <input
                  v-model="el.question"
                  class="form-control"
                  placeholder="Вопрос"
              />
            </div>

            <!-- Ответ и кнопка удалить -->
            <textarea
                v-model="el.answer"
                class="form-control"
                rows="12"
                placeholder="Ответ"
            ></textarea>

            <button class="btn btn-sm btn-danger mt-1" @click="remove(index)">
              Удалить
            </button>

          </div>
        </div>
      </template>
    </draggable>

    <button v-if="!allCollapsed" class="btn btn-sm btn-primary mt-2" @click="add">
      Добавить вопрос
    </button>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, watch } from 'vue'
import { debounce, omit } from 'lodash'
import draggable from 'vuedraggable'

const emit = defineEmits(['onUpdate'])
const props = defineProps({ payload: Object })

const data = reactive({
  label: '',
  items: []
})

const allCollapsed = ref(false)  // состояние свёртывания всех карточек

onMounted(() => {
  Object.assign(data, props.payload.data ?? {})

  if (!data.items.length) {
    data.items = [{ id: 1, question: '', answer: '' }]
  } else {
    data.items = data.items.map((i, idx) => ({ id: idx + 1, ...i }))
  }

  emitUpdate()
})

function add() {
  const nextId = data.items.length ? Math.max(...data.items.map(i => i.id)) + 1 : 1
  data.items.push({ id: nextId, question: '', answer: '' })
}

function remove(i) {
  data.items.splice(i, 1)
}

function toggleAll() {
  allCollapsed.value = !allCollapsed.value
}

const emitUpdate = debounce(() => {
  emit('onUpdate', {
    type: 'faq',
    data: {
      label: data.label,
      items: data.items.map(item => omit(item, ['id']))
    }
  })
}, 300)

watch(data, emitUpdate, {deep: true})
</script>

<style scoped>
.drag-ghost {
  opacity: 0.5;
}
</style>
